import { useState } from 'react';

const ProviderTable = ({ users, onEdit, onDelete }) => {
    return (
        <div className="bg-white/20 rounded-xl shadow-sm border border-gray-200 overflow-hidden">

            <div className="overflow-x-auto">
                <table className="w-full">
                    <thead className="bg-gray-50/10">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-100 uppercase tracking-wider">
                                SL
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-100 uppercase tracking-wider">
                                Name
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-100 uppercase tracking-wider">
                                Email
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-100 uppercase tracking-wider">
                                Phone
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-100 uppercase tracking-wider">
                                Actions
                            </th>
                        </tr>
                    </thead>
                    <tbody className="bg-white/10 divide-y divide-gray-200/20 text-white">
                        {users?.length > 0 ? (
                            users?.map((user, i) => (
                                <tr key={user._id} className="table-row">
                                    <td className="px-6 py-4 whitespace-nowrap ">{i + 1}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">


                                        <div className="">
                                            <div className="text-sm font-medium ">{user?.name}</div>
                                        </div>

                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm ">{user.email}</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm ">{user.phone}</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium space-x-2">
                                        <button
                                            onClick={() => onEdit(user)}
                                            className="action-btn bg-blue-100 text-blue-700 hover:bg-blue-200 focus:ring-blue-500"
                                        >
                                            Edit
                                        </button>
                                        {/* <button
                                            onClick={() => onDelete(user.id)}
                                            className="action-btn bg-red-100 text-red-700 hover:bg-red-200 focus:ring-red-500"
                                        >
                                            Delete
                                        </button> */}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" className="px-6 py-8 text-center">
                                    <div className="text-gray-500">
                                        <svg
                                            className="mx-auto h-12 w-12 text-gray-400 mb-4"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
                                            />
                                        </svg>
                                        <p className="text-sm">No users found</p>
                                        <p className="text-xs text-gray-400 mt-1">
                                            Get started by adding your first user
                                        </p>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ProviderTable;